import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Box, Stack } from "@mui/material";
import { SwiperSlide } from "swiper/react";
import videoImage from "../../assets/learning/video.webp";
import VSNPaper from "../../shared/VSNPaper";
import VSNProgressiveImage from "../../shared/VSNProgressiveImage";
import { VSNSwiper } from "../../shared/VSNSwiper";
import VSNTypography from "../../shared/VSNTypography";
import { LearningStyle } from "./LearningStyle";

const LearningSwiperComponent = ({
  title,
  description,
  cardData,
  onCardClick,
  onBookmark,
  getContentTypeDetails,
  bookmarkedIds = [],
  showBookmark = true,
  navigationClass = "swiper",
  exploreAll,
}) => {
  const classes = LearningStyle();

  return (
    <Box py={4} mx={{ md: 12, xs: 2 }}>
      <Stack
        className={classes.sliderHeader}
        onClick={() => exploreAll()}
        sx={{ cursor: "pointer" }}
      >
        <VSNTypography variant="h2">{title}</VSNTypography>
        <Stack
          gap={1}
          direction={{ xts: "row" }}
          justifyContent="space-between"
        >
          <VSNTypography variant="h5">{description}</VSNTypography>

          <VSNTypography variant="h4">
            <VSNTypography component="span">Explore All</VSNTypography>{" "}
            <ArrowForwardIcon />
          </VSNTypography>
        </Stack>
      </Stack>

      <Box
        className={`${classes.yourPersonalitySliderMain} ${classes.zoomEffectSlider} ${classes.videoSlider}`}
      >
        {/* <Box className={`button-prev ${navigationClass}-prev`}>
          <KeyboardArrowLeftIcon />
        </Box> */}

        <VSNSwiper
          className={classes.personalityMain}
          pagination
          navigation={{
            nextEl: `.${navigationClass}-next`,
            prevEl: `.${navigationClass}-prev`,
          }}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 20 },
            700: { slidesPerView: 2, spaceBetween: 20 },
            1300: { slidesPerView: 3, spaceBetween: 20 },
            1400: { slidesPerView: 4, spaceBetween: 25 },
            1800: { slidesPerView: 4, spaceBetween: 25 },
          }}
        >
          {cardData?.map((el, index) => {
            const { icon, label, content, samllIcon } = getContentTypeDetails(
              el?.course_content?.content_type?.toLowerCase()
            );
            return (
              <SwiperSlide key={index}>
                <Box
                  onClick={() => onCardClick?.(el)}
                  sx={{ cursor: "pointer" }}
                >
                  <VSNPaper
                    className={`${classes.videosBox} ${content}`}
                    maxHeight="250px"
                  >
                    <VSNProgressiveImage
                      src={el?.course_content?.thumbnail}
                      placeholder={videoImage}
                      alt={el?.course_content?.title}
                      style={{
                        objectFit: "cover",
                        minHeight: "250px",
                        height: "100%",
                        borderRadius: "10px 10px 0 0",
                      }}
                    />
                    <Box className={classes.typeIcon}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          px: 1,
                        }}
                      >
                        {icon}
                        <VSNTypography fontSize="12px" fontWeight="500">
                          {content}
                        </VSNTypography>
                      </Box>
                    </Box>

                    <Stack className={classes.zoomVideoBoxInfo}>
                      <VSNTypography
                        variant="body1"
                        color="white.main"
                        textAlign="left"
                        className={classes.contentHead}
                      >
                        {el?.course_content?.title}
                      </VSNTypography>
                      <VSNTypography
                        className={classes.subText}
                        dangerouslySetInnerHTML={{
                          __html: el?.course_content?.summary,
                        }}
                      />
                      <VSNTypography
                        className={classes.partnerLogo}
                        dangerouslySetInnerHTML={{
                          __html: el?.course_content?.partner_logo,
                        }}
                      />
                      <Stack
                        direction="row"
                        className={classes.btnWrap}
                        alignItems="center"
                      >
                        <VSNTypography
                          variant="body2"
                          color="white.main"
                          textAlign="left"
                          sx={{
                            textDecoration: "underline",
                          }}
                        >
                          <span>{samllIcon}</span>
                          {label}
                        </VSNTypography>

                        {/* {showBookmark && (
                          <Box
                            onClick={(e) => {
                              e.stopPropagation();
                              onBookmark?.(e, el?.course_id, el);
                            }}
                          >
                            {bookmarkedIds.includes(el?.course_id) ? (
                              <RemoveCircleOutlineIcon />
                            ) : (
                              <AddCircleOutlineIcon />
                            )}
                          </Box>
                        )} */}
                      </Stack>
                    </Stack>
                  </VSNPaper>
                </Box>
              </SwiperSlide>
            );
          })}
        </VSNSwiper>

        {/* <Box className={`button-next ${navigationClass}-next`}>
          <ChevronRightIcon />
        </Box> */}
      </Box>
    </Box>
  );
};

export default LearningSwiperComponent;
